import JobListingsTable from "./JobListingsTable";

const index = () => {
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          {/* <!-- Ls widget --> */}
          <div className="ls-widget">
            <JobListingsTable />
          </div>
        </div>
      </div>
    </>
  );
};

export default index;
